import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue";
const _hoisted_1 = /*#__PURE__*/ _createTextVNode(" To save your molecules in other formats, consider ");
const _hoisted_2 = /*#__PURE__*/ _createTextVNode(" If you wish only to duplicate molecules (\"copy and paste\"), consider ");
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_Alert = _resolveComponent("Alert");
    const _component_PluginPathLink = _resolveComponent("PluginPathLink");
    const _component_PluginComponent = _resolveComponent("PluginComponent");
    return (_openBlock(), _createBlock(_component_PluginComponent, {
        modelValue: _ctx.open,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((_ctx.open) = $event)),
        infoPayload: _ctx.infoPayload,
        onOnUserArgChanged: _ctx.onUserArgChanged,
        actionBtnTxt: "Copy"
    }, {
        default: _withCtx(() => [
            _createVNode(_component_Alert, { type: "info" }, {
                default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.formatMsg), 1)
                ]),
                _: 1
            }),
            _createVNode(_component_Alert, { type: "warning" }, {
                default: _withCtx(() => [
                    _hoisted_1,
                    _createVNode(_component_PluginPathLink, { plugin: "savemolecules" }),
                    _hoisted_2,
                    _createVNode(_component_PluginPathLink, { plugin: "clonemol" })
                ]),
                _: 1
            })
        ]),
        _: 1
    }, 8, ["modelValue", "infoPayload", "onOnUserArgChanged"]));
}
